import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import ava from "../../../../assets/doctor.png";

export const StyledHeader = styled("header")(() => ({
  display: "flex",
  backgroundColor: "#13709e",
  color: "white",
}));

export const HeaderElement = styled("span")(() => ({
  padding: 16,
  fontSize: 12,
  cursor: "pointer",
  ":hover": {
    backgroundColor: "#10587c",
  },
}));

export const HeaderLogoutButton = styled(IconButton)(() => ({
  color: "white",
}));

export const UserAvatar = styled(Box)(() => ({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundImage: `url(${ava})`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  ":hover": {
    cursor: "pointer",
  },
}));
